import { RuleParamSchema } from "vee-validate/dist/types/types";
import { isUndefinedOrNullOrEmptyString } from "@/module/Validation/rules/isUndefinedOrNullOrEmptyString";

const validate = async (
  value: any,
  { country }: Record<string, any>,
): Promise<boolean> => {
  if (isUndefinedOrNullOrEmptyString(value)) {
    return false;
  }

  const { checkVAT, countries } = await import(
    /* webpackChunkName: "vat-validation" */ "jsvat"
  );

  value = String(value);
  let filteredCountries = countries;

  if (value !== "") {
    filteredCountries = countries.filter((ele) => ele.codes.includes(country));
  }

  if (filteredCountries.length === 0) {
    return false;
  }

  const vat = checkVAT(value, filteredCountries);

  return vat.isValid;
};

const params: RuleParamSchema[] = [
  {
    name: "country",
  },
];

export { validate, params };

export default {
  validate,
  params,
};
